export default {"src":"/_next/static/media/cn-logo-dark.690941b3.svg","height":32,"width":202,"blurWidth":0,"blurHeight":0};